import { FC } from "react";
import caseStudy1 from "../../Assets/TalentOnDemand/case-study1.png";
import caseStudy2 from "../../Assets/TalentOnDemand/case-study2.png";

const caseStudies = [
    {
        title: "Recruitment Case Study",
        label: "PROVEN SUCCESS",
        image: caseStudy1,
        link: "https://calendly.com/salesbox-meet/talent-ondemand-package",
    },
    {
        title: "Top Talent Success",
        label: "PROVEN SUCCESS",
        image: caseStudy2,
        link: "https://calendly.com/salesbox-meet/talent-ondemand-package",
    },
];

const TalentOnDemandTechCaseStudies: FC = () => {
    return (
        <section className="w-full py-16 px-6 bg-white">
            <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row gap-10 items-start justify-between">
                {/* LEFT SIDE */}
                <div className="flex flex-col h-fit my-auto gap-6 max-w-sm">
                    <h2 className="text-6xl text-center lg:text-left my-auto font-bold text-black">Case Studies</h2>
                    <p className="text-gray-700 text-center lg:text-left text-lg">
                        We help leading tech companies find the perfect talent to build their teams.
                    </p>
                </div>

                {/* RIGHT SIDE: CASE STUDIES */}
                <div className="flex flex-col lg:flex-row gap-6 w-full">
                    {caseStudies.map((study, index) => (
                        <a
                            target="_blank"
                            href={study.link}
                            key={index}
                            className="relative rounded-xl overflow-hidden w-full max-w-md shadow-md group cursor-pointer"
                        >
                            <img
                                src={study.image}
                                alt={study.title}
                                className="w-full h-full object-cover transition-transform group-hover:scale-105"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandTechCaseStudies;
